module.exports = __webpack_public_path__ + "main_logo.svg?b93d1e5a1542632e654d0e909817a38f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ryerson/main_logo.svg
// module id = 586
// module chunks = 0